import React, { useEffect, useState } from "react";
import { Form, FormGroup, Label } from "reactstrap";
import Utils from "../../utils";
import { toast } from "react-toastify";
import {
  createListCustomer,
  getDeliveryMethodList,
  getLanguageList,
  getListCountry,
  getListSalesmenList,
  getMaturityDatesList,
  getPaymentMethodList,
  getProductPriceClassList,
  getTimeZoneList,
  updateListCustomer,
  getDocumentSetList,
  getTaxList,
} from "../../services/MoloniServices";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import ConfigDB from "../../config";

const AddCustomerMoloni = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { state } = useLocation();
  const { uuid } = useParams();
  const [isModifyButtonLoad, setIsModifyButtonLoad] = useState(false);
  const [customerData, setCustomerData] = useState({
    id: "",
    vat: "",
    number: "",
    name: "",
    language_id: "",
    qty_copies_document: "",
    notes: "",
    country_id: "",
    address: "",
    zip_code: "",
    city: "",
    email: "",
    website: "",
    phone: "",
    fax: "",
    contact_name: "",
    contact_email: "",
    contact_phone: "",
    discount: "",
    credit_limit: "",
    payment_method_id: "",
    delivery_method_id: "",
    maturity_date_id: "",
    field_notes: "",
    salesman_id: "",
    price_class_id: "",
    payment_day: "",
    document_type_id: "",
    moloni_id: "",
    alternate_address: [],
  });

  let errorsObj = {
    vat: "",
    number: "",
    name: "",
    language_id: "",
    qty_copies_document: "",
    notes: "",
    country_id: "",
    address: "",
    zip_code: "",
    city: "",
    email: "",
    website: "",
    phone: "",
    fax: "",
    contact_name: "",
    contact_email: "",
    contact_phone: "",
    discount: "",
    credit_limit: "",
    payment_method_id: "",
    delivery_method_id: "",
    maturity_date_id: "",
    field_notes: "",
    salesman_id: "",
    price_class_id: "",
    payment_day: "",
    document_type_id: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [currentStep, setCurrentStep] = useState("step1");
  const [timeZoneList, setTimeZoneList] = useState([]);
  const [languageList, setLanguageList] = useState([]);
  const [paymentMethodList, setPaymentMethodList] = useState([]);
  const [deliveryMethodList, setDeliveryMethodList] = useState([]);
  const [maturityDatesList, setMaturityDatesList] = useState([]);
  const [priceClassList, setPriceClassList] = useState([]);
  const [salesmenList, setSalesmenDatesList] = useState([]);
  const [activeCustomerTab, setActiveCustomerTab] = useState("1");
  const [countryList, setCountryList] = useState([]);
  const [altForm, setAltForm] = useState({
    description: "",
    code: "",
    address: "",
    zip_code: "",
    city: "",
    country: "",
    email: "",
    phone: "",
    fax: "",
    contact_person: "",
  });
  const [editIndex, setEditIndex] = useState(null);
  const [documentSetList, setDocumentSetList] = useState([]);
  const [taxDataList, setTaxDataList] = useState([]);

  const handleAltChange = (e) => {
    setAltForm({
      ...altForm,
      [e.target.name]: e.target.value,
    });
  };

  const resetAltForm = () => {
    setAltForm({
      description: "",
      code: "",
      address: "",
      zip_code: "",
      city: "",
      country: "",
      email: "",
      phone: "",
      fax: "",
      contact_person: "",
    });
    setEditIndex(null);
  };

  const editAlternateAddress = (index) => {
    setAltForm({ ...customerData.alternate_address[index] });
    setEditIndex(index);
  };

  const deleteAlternateAddress = (index) => {
    const updated = customerData?.alternate_address?.filter(
      (_, i) => i !== index,
    );

    setCustomerData({
      ...customerData,
      alternate_address: updated,
    });
  };

  const saveAlternateAddress = () => {
    if (
      !altForm.description ||
      !altForm.code ||
      !altForm.address ||
      !altForm.zip_code ||
      !altForm.city ||
      !altForm.country
    ) {
      toast.error("Please fill all required fields");
      return;
    }

    const updatedList = [...(customerData?.alternate_address || [])];

    if (editIndex !== null) {
      updatedList[editIndex] = altForm;
    } else {
      updatedList.push(altForm);
    }

    setCustomerData((prev) => ({
      ...prev,
      alternate_address: updatedList,
    }));

    resetAltForm();
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getTaxList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setTaxDataList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDocumentSetList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDocumentSetList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(() => {
    if (state) {
      setCustomerData({
        id: state?.id,
        vat: state?.vat,
        number: state?.number,
        name: state?.name,
        language_id: state?.language_id,
        qty_copies_document: state?.qty_copies_document,
        notes: state?.notes,
        country_id: state?.country_id,
        address: state?.address,
        zip_code: state?.zip_code,
        city: state?.city,
        email: state?.email,
        website: state?.website,
        phone: state?.phone,
        contact_name: state?.contact_name,
        contact_email: state?.contact_email,
        contact_phone: state?.contact_phone,
        discount: state?.discount,
        credit_limit: state?.credit_limit,
        payment_method_id: state?.payment_method_id,
        delivery_method_id: state?.delivery_method_id,
        maturity_date_id: state?.maturity_date_id,
        field_notes: state?.field_notes,
        moloni_id: state?.moloni_id,
        fax: state?.fax,
        salesman_id: state?.salesman_id,
        price_class_id: state?.price_class_id,
        payment_day: state?.payment_day,
        document_type_id: state?.document_type_id,
      });
    }
  }, [state]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getTimeZoneList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].code,
            label: response.data[i].code,
          });
        }

        setTimeZoneList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCountry(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setCountryList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCountry(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setTimeZoneList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getLanguageList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].language_id,
            label: response.data[i].title,
          });
        }

        setLanguageList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getPaymentMethodList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setPaymentMethodList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDeliveryMethodList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDeliveryMethodList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getMaturityDatesList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setMaturityDatesList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getProductPriceClassList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].title,
          });
        }

        setPriceClassList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListSalesmenList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setSalesmenDatesList(list);
      })
      .catch((err) => {});
  }, []);

  const handleSubmitForm = (e) => {
    e.preventDefault();
    let error = false;
    let errorObj = { ...errorsObj };

    if (!customerData.vat) {
      toast.error("Vat is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.number) {
      toast.error("Number is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.name) {
      toast.error("Name is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.language_id) {
      setActiveCustomerTab("4");
      toast.error("Language is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.address) {
      toast.error("Address is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.city) {
      toast.error("City is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.zip_code) {
      toast.error("Zip Code is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.country_id) {
      toast.error("Country is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.email) {
      toast.error("Email is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.maturity_date_id) {
      toast.error("Maturity Date is required.");
      setActiveCustomerTab("4");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.payment_method_id) {
      toast.error("Payment Method is required.");
      setActiveCustomerTab("4");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.email) {
      toast.error("Email is required.");
      setActiveCustomerTab("2");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.phone) {
      toast.error("Phone is required.");
      setActiveCustomerTab("2");
      setIsModifyButtonLoad(false);
      return;
    }

    setIsModifyButtonLoad(true);

    let data = {
      company_id: "269134",
      vat: customerData?.vat,
      number: customerData?.number,
      name: customerData?.name,
      language_id: customerData?.language_id,
      qty_copies_document: customerData?.qty_copies_document,
      notes: customerData?.notes,
      country_id: customerData?.country_id,
      address: customerData?.address,
      zip_code: customerData?.zip_code,
      city: customerData?.city,
      email: customerData?.email,
      website: customerData?.website,
      phone: customerData?.phone,
      fax: customerData?.fax,
      contact_name: customerData?.contact_name,
      contact_email: customerData?.contact_email,
      contact_phone: customerData?.contact_phone,
      discount: customerData?.discount,
      credit_limit: customerData?.credit_limit,
      payment_method_id: customerData?.payment_method_id,
      delivery_method_id: customerData?.delivery_method_id,
      maturity_date_id: customerData?.maturity_date_id,
      field_notes: customerData?.field_notes,
      salesman_id: customerData?.salesman_id,
      price_class_id: customerData?.price_class_id,
      payment_day: customerData?.payment_day,
      document_type_id: 0,
      // alternate_address: customerData?.alternate_address
    };

    let updateData = {
      company_id: "269134",
      id: customerData?.id,
      vat: customerData?.vat,
      number: customerData?.number,
      name: customerData?.name,
      language_id: customerData?.language_id,
      qty_copies_document: customerData?.qty_copies_document,
      notes: customerData?.notes,
      country_id: customerData?.country_id,
      address: customerData?.address,
      zip_code: customerData?.zip_code,
      city: customerData?.city,
      email: customerData?.email,
      website: customerData?.website,
      phone: customerData?.phone,
      fax: customerData?.fax,
      contact_name: customerData?.contact_name,
      contact_email: customerData?.contact_email,
      contact_phone: customerData?.contact_phone,
      discount: customerData?.discount,
      credit_limit: customerData?.credit_limit,
      payment_method_id: customerData?.payment_method_id,
      delivery_method_id: customerData?.delivery_method_id,
      maturity_date_id: customerData?.maturity_date_id,
      field_notes: customerData?.field_notes,
      salesman_id: customerData?.salesman_id,
      price_class_id: customerData?.price_class_id,
      payment_day: customerData?.payment_day,
      document_type_id: 0,
      customer_id: customerData?.moloni_id,
      // alternate_address: customerData?.alternate_address
    };

    if (customerData?.id) {
      updateListCustomer(updateData)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/customers");

          setIsModifyButtonLoad(false);
          setCustomerData({
            id: "",
            vat: "",
            number: "",
            name: "",
            language_id: "",
            qty_copies_document: "",
            notes: "",
            country_id: "",
            address: "",
            zip_code: "",
            city: "",
            email: "",
            website: "",
            phone: "",
            fax: "",
            contact_name: "",
            contact_email: "",
            contact_phone: "",
            discount: "",
            credit_limit: "",
            payment_method_id: "",
            delivery_method_id: "",
            maturity_date_id: "",
            field_notes: "",
            salesman_id: "",
            price_class_id: "",
            payment_day: "",
            document_type_id: "",
            moloni_id: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    } else {
      createListCustomer(data)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/customers");
          setIsModifyButtonLoad(false);

          setCustomerData({
            id: "",
            vat: "",
            number: "",
            name: "",
            language_id: "",
            qty_copies_document: "",
            notes: "",
            country_id: "",
            address: "",
            zip_code: "",
            city: "",
            email: "",
            website: "",
            phone: "",
            fax: "",
            contact_name: "",
            contact_email: "",
            contact_phone: "",
            discount: "",
            credit_limit: "",
            payment_method_id: "",
            delivery_method_id: "",
            maturity_date_id: "",
            field_notes: "",
            salesman_id: "",
            price_class_id: "",
            payment_day: "",
            document_type_id: "",
            moloni_id: "",
          });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    }
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6 d-flex align-items-center"></div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="card card-primary">
              <div className="card-body">
                <div className="row justify-content-start">
                  <div className="col-md-12">
                    <h5 className="page-title">Customers</h5>
                    <h5 className="page-title">
                      {uuid
                        ? `In this section you can change the customer ${customerData?.name}`
                        : "In this section you can insert a new customer"}
                    </h5>

                    <Form method={`post`} onSubmit={handleSubmitForm}>
                      <div className="row">
                        <div className="mb-3">
                          {/* Tabs */}
                          <ul className="custom-tabs">
                            <li
                              className={
                                activeCustomerTab === "1"
                                  ? "tab-item active"
                                  : "tab-item"
                              }
                              onClick={() => setActiveCustomerTab("1")}
                            >
                              {t("main")}
                            </li>

                            <li
                              className={
                                activeCustomerTab === "2"
                                  ? "tab-item active"
                                  : "tab-item"
                              }
                              onClick={() => setActiveCustomerTab("2")}
                            >
                              {t("contact")}
                            </li>

                            <li
                              className={
                                activeCustomerTab === "3"
                                  ? "tab-item active"
                                  : "tab-item"
                              }
                              onClick={() => setActiveCustomerTab("3")}
                            >
                              {t("otherAddresses")}
                            </li>

                            <li
                              className={
                                activeCustomerTab === "4"
                                  ? "tab-item active"
                                  : "tab-item"
                              }
                              onClick={() => setActiveCustomerTab("4")}
                            >
                              {t("billingSettings")}
                            </li>
                          </ul>

                          <div className="tab-content-area">
                            {activeCustomerTab === "1" && (
                              <div className="row">
                                <div class="alert alert-light" role="alert">
                                  NOTE: All required fields are marked with{" "}
                                  <span style={{ color: "red" }}>(*)</span>
                                </div>

                                <p>General Information</p>
                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("vat")}{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={customerData.vat}
                                        onChange={(e) => {
                                          setCustomerData({
                                            ...customerData,
                                            vat: e.target.value,
                                          });
                                        }}
                                        name={`vat`}
                                        maxLength={50}
                                        placeholder="Vat"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>

                                {/* <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("customerCode")}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={customerData.customer_code}
                                        onChange={(e) => {
                                          setCustomerData({
                                            ...customerData,
                                            customer_code: e.target.value,
                                          });
                                        }}
                                        name={`customer_code`}
                                        maxLength={50}
                                        placeholder="Customer Code"
                                      />
                                    </div>
                                  </FormGroup>
                                </div> */}

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("number")}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={customerData.number}
                                        onChange={(e) => {
                                          setCustomerData({
                                            ...customerData,
                                            number: e.target.value,
                                          });
                                        }}
                                        name={`number`}
                                        maxLength={50}
                                        placeholder="Number"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("Name")}{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={customerData.name}
                                        onChange={(e) => {
                                          setCustomerData({
                                            ...customerData,
                                            name: e.target.value,
                                          });
                                        }}
                                        name={`name`}
                                        maxLength={50}
                                        placeholder="Name"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>
                                <div className="col-md-4" />
                                <div className="col-md-4" />

                                <div class="alert alert-primary" role="alert">
                                  Fill with default data
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("address")}
                                    </Label>
                                    <span className="text-danger">*</span>

                                    <div className="col-xl-12">
                                      <textarea
                                        className="form-control input-search"
                                        type="text"
                                        value={customerData.address}
                                        onChange={(e) => {
                                          setCustomerData({
                                            ...customerData,
                                            address: e.target.value,
                                          });
                                        }}
                                        name={`address`}
                                        maxLength={50}
                                        placeholder="Address"
                                        rows={3}
                                      />
                                    </div>
                                  </FormGroup>
                                </div>
                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("city")}
                                    </Label>
                                    <span className="text-danger">*</span>

                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={customerData.city}
                                        onChange={(e) => {
                                          setCustomerData({
                                            ...customerData,
                                            city: e.target.value,
                                          });
                                        }}
                                        name={`city`}
                                        maxLength={50}
                                        placeholder="City"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>
                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("zip_code")}
                                    </Label>
                                    <span className="text-danger">*</span>

                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={customerData.zip_code}
                                        onChange={(e) => {
                                          setCustomerData({
                                            ...customerData,
                                            zip_code: e.target.value,
                                          });
                                        }}
                                        name={`zip_code`}
                                        maxLength={50}
                                        placeholder="Zip code"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("country")}
                                    </Label>
                                    <span className="text-danger">*</span>

                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={countryList}
                                          value={countryList.find(
                                            (item) =>
                                              item.value ==
                                              customerData.country_id,
                                          )}
                                          onChange={(selectedOption) => {
                                            setCustomerData({
                                              ...customerData,
                                              country_id: selectedOption
                                                ? selectedOption.value
                                                : "",
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={"Select Country"}
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4 d-none">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("geographicalArea")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={countryList}
                                          value={countryList.find(
                                            (item) =>
                                              item.value ==
                                              customerData.country_id,
                                          )}
                                          onChange={(selectedOption) => {
                                            setCustomerData({
                                              ...customerData,
                                              country_id: selectedOption
                                                ? selectedOption.value
                                                : "",
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={"Select Country"}
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("email")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={customerData.email}
                                        onChange={(e) => {
                                          setCustomerData({
                                            ...customerData,
                                            email: e.target.value,
                                          });
                                        }}
                                        name={`email`}
                                        maxLength={50}
                                        placeholder="Contact email"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4" />
                              </div>
                            )}

                            {activeCustomerTab === "2" && (
                              <div className="row">
                                <div class="alert alert-light" role="alert">
                                  NOTE: All required fields are marked with{" "}
                                  <span style={{ color: "red" }}>(*)</span>
                                </div>

                                <p>Contacts</p>
                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("phone")}
                                    </Label>
                                    <span className="text-danger">*</span>
                                    <div className="input-div">
                                      <input
                                        className="form-control input-search"
                                        type="number"
                                        value={customerData.phone}
                                        onChange={(e) => {
                                          setCustomerData({
                                            ...customerData,
                                            phone: e.target.value,
                                          });
                                        }}
                                        name={`phone`}
                                        placeholder="Phone"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("fax")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="number"
                                        value={customerData.fax}
                                        onChange={(e) => {
                                          setCustomerData({
                                            ...customerData,
                                            fax: e.target.value,
                                          });
                                        }}
                                        name={`fax`}
                                        placeholder="Fax"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("website")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={customerData.website}
                                        onChange={(e) => {
                                          setCustomerData({
                                            ...customerData,
                                            website: e.target.value,
                                          });
                                        }}
                                        name={`website`}
                                        placeholder="website"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("contactPerson")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={customerData.contact_person}
                                        onChange={(e) => {
                                          setCustomerData({
                                            ...customerData,
                                            contact_person: e.target.value,
                                          });
                                        }}
                                        name={`contact_person`}
                                        placeholder="Contact Person"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("contactEmail")}
                                    </Label>
                                    <span className="text-danger">*</span>

                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={customerData.contact_email}
                                        onChange={(e) => {
                                          setCustomerData({
                                            ...customerData,
                                            contact_email: e.target.value,
                                          });
                                        }}
                                        name={`contact_email`}
                                        placeholder="Contact Email"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("telephoneContact")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        value={customerData.telephone_contact}
                                        onChange={(e) => {
                                          setCustomerData({
                                            ...customerData,
                                            telephone_contact: e.target.value,
                                          });
                                        }}
                                        name={`telephone_contact`}
                                        placeholder="Telephone Contact"
                                      />
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-12">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("contactNotes")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <textarea
                                        className="form-control input-search"
                                        type="text"
                                        value={customerData.contact_notes}
                                        onChange={(e) => {
                                          setCustomerData({
                                            ...customerData,
                                            contact_notes: e.target.value,
                                          });
                                        }}
                                        name={`contact_notes`}
                                        placeholder="Contact Notes"
                                        rows={4}
                                      />
                                    </div>
                                  </FormGroup>
                                </div>
                              </div>
                            )}

                            {activeCustomerTab === "3" && (
                              <>
                                <div className="row">
                                  <div
                                    className="alert alert-light"
                                    role="alert"
                                  >
                                    NOTE: All required fields are marked with{" "}
                                    <span style={{ color: "red" }}>(*)</span>
                                  </div>

                                  <p>Alternate Address</p>

                                  <div className="col-md-4">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        Description
                                      </Label>
                                      <span className="text-danger">*</span>

                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        name="description"
                                        value={altForm.description}
                                        onChange={handleAltChange}
                                        placeholder="Description"
                                      />
                                    </FormGroup>
                                  </div>

                                  <div className="col-md-4">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        Code
                                      </Label>
                                      <span className="text-danger">*</span>

                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        name="code"
                                        value={altForm.code}
                                        onChange={handleAltChange}
                                        placeholder="Code"
                                      />
                                    </FormGroup>
                                  </div>

                                  <div className="col-md-4">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        Zip Code
                                      </Label>
                                      <span className="text-danger">*</span>

                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        name="zip_code"
                                        value={altForm.zip_code}
                                        onChange={handleAltChange}
                                        placeholder="Zip Code"
                                      />
                                    </FormGroup>
                                  </div>

                                  <div className="col-md-4">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        City
                                      </Label>
                                      <span className="text-danger">*</span>

                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        name="city"
                                        value={altForm.city}
                                        onChange={handleAltChange}
                                        placeholder="City"
                                      />
                                    </FormGroup>
                                  </div>

                                  {/* Country */}
                                  <div className="col-md-4">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        Country
                                      </Label>
                                      <span className="text-danger">*</span>

                                      <Select
                                        className="my-select-v"
                                        options={countryList}
                                        value={
                                          countryList.find(
                                            (item) =>
                                              item.value === altForm.country,
                                          ) || null
                                        }
                                        onChange={(selectedOption) => {
                                          setAltForm({
                                            ...altForm,
                                            country: selectedOption
                                              ? selectedOption.value
                                              : "",
                                          });
                                        }}
                                        isSearchable={true}
                                        isClearable={true}
                                        placeholder="Select Country"
                                      />
                                    </FormGroup>
                                  </div>

                                  {/* Email */}
                                  <div className="col-md-4">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        E-mail
                                      </Label>
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        name="email"
                                        value={altForm.email}
                                        onChange={handleAltChange}
                                        placeholder="Email"
                                      />
                                    </FormGroup>
                                  </div>

                                  {/* Phone */}
                                  <div className="col-md-4">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        Phone
                                      </Label>
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        name="phone"
                                        value={altForm.phone}
                                        onChange={handleAltChange}
                                        placeholder="Phone"
                                      />
                                    </FormGroup>
                                  </div>

                                  {/* Fax */}
                                  <div className="col-md-4">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        Fax
                                      </Label>
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        name="fax"
                                        value={altForm.fax}
                                        onChange={handleAltChange}
                                        placeholder="Fax"
                                      />
                                    </FormGroup>
                                  </div>

                                  {/* Contact Person */}
                                  <div className="col-md-4">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        Contact Person
                                      </Label>
                                      <input
                                        className="form-control input-search"
                                        type="text"
                                        name="contact_person"
                                        value={altForm.contact_person}
                                        onChange={handleAltChange}
                                        placeholder="Contact Person"
                                      />
                                    </FormGroup>
                                  </div>

                                  <div className="col-md-12">
                                    <FormGroup>
                                      <Label className="col-form-label ml-2 Label-my form-label form-label">
                                        Address
                                      </Label>
                                      <span className="text-danger">*</span>

                                      <textarea
                                        className="form-control input-search"
                                        rows={4}
                                        name="address"
                                        value={altForm.address}
                                        onChange={handleAltChange}
                                        placeholder="Address"
                                      />
                                    </FormGroup>
                                  </div>

                                  <div className="col-md-12 mt-3">
                                    <button
                                      className="btn btn-primary"
                                      onClick={saveAlternateAddress}
                                      type="button"
                                    >
                                      {editIndex !== null
                                        ? "Update Address"
                                        : "Add Address"}
                                    </button>
                                  </div>
                                </div>

                                <div>
                                  {customerData?.alternate_address?.length >
                                    0 && (
                                    <table className="table table-bordered mt-4">
                                      <thead>
                                        <tr>
                                          <th>Code</th>
                                          <th>City</th>
                                          <th>Country</th>
                                          <th>Email</th>
                                          <th style={{ width: "120px" }}>
                                            Actions
                                          </th>
                                        </tr>
                                      </thead>

                                      <tbody>
                                        {customerData?.alternate_address?.map(
                                          (item, index) => (
                                            <tr key={index}>
                                              <td>{item.code}</td>
                                              <td>{item.city}</td>
                                              <td>{item.country}</td>
                                              <td>{item.email}</td>
                                              <td>
                                                <div className="d-flex gap-2">
                                                  <button
                                                    className="btn btn-sm"
                                                    type="button"
                                                    onClick={() =>
                                                      editAlternateAddress(
                                                        index,
                                                      )
                                                    }
                                                  >
                                                    <i className="bi bi-pencil"></i>
                                                  </button>

                                                  <button
                                                    className="btn btn-sm"
                                                    type="button"
                                                    onClick={() =>
                                                      deleteAlternateAddress(
                                                        index,
                                                      )
                                                    }
                                                  >
                                                    <i className="bi bi-trash3"></i>
                                                  </button>
                                                </div>
                                              </td>
                                            </tr>
                                          ),
                                        )}
                                      </tbody>
                                    </table>
                                  )}
                                </div>
                              </>
                            )}

                            {activeCustomerTab === "4" && (
                              <div className="row">
                                <div className="alert alert-light" role="alert">
                                  NOTE: All required fields are marked with{" "}
                                  <span style={{ color: "red" }}>(*)</span>
                                </div>

                                <p>Billing Settings</p>

                                <div className="col-md-4 d-none">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label d-none">
                                      {t("Visibility")}
                                    </Label>
                                    <span className="text-danger">*</span>

                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={
                                            ConfigDB?.data?.visibilityList
                                          }
                                          value={ConfigDB?.data?.visibilityList.find(
                                            (item) =>
                                              item.value ==
                                              customerData.visibility,
                                          )}
                                          onChange={(selectedOption) => {
                                            setCustomerData({
                                              ...customerData,
                                              visibility: selectedOption
                                                ? selectedOption.value
                                                : "",
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={"Select Visibility"}
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>
                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("language")}
                                    </Label>
                                    <span className="text-danger">*</span>

                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={languageList}
                                          value={languageList.find(
                                            (item) =>
                                              item.value ==
                                              customerData.language_id,
                                          )}
                                          onChange={(selectedOption) => {
                                            setCustomerData({
                                              ...customerData,
                                              language_id: selectedOption
                                                ? selectedOption.value
                                                : "",
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={"Select Language"}
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4 d-none">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                                      {t("customer_iva")}
                                    </Label>

                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <div className="form-check">
                                          <input
                                            className="my-checkbox-1 form-check-input"
                                            type="checkbox"
                                            checked={
                                              customerData.customer_iva === 1
                                            }
                                            onChange={(e) => {
                                              setCustomerData({
                                                ...customerData,
                                                customer_iva: e.target.checked
                                                  ? 1
                                                  : 0,
                                              });
                                            }}
                                          />
                                          <label className="form-check-label pl-2">
                                            {t("customer_iva")}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4 d-none">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("seriesByDefault")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={documentSetList}
                                          value={documentSetList.find(
                                            (item) =>
                                              item.value ==
                                              customerData.series_id,
                                          )}
                                          onChange={(selectedOption) => {
                                            setCustomerData({
                                              ...customerData,
                                              series_id: selectedOption
                                                ? selectedOption.value
                                                : "",
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={
                                            "Select Series By Default"
                                          }
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4 d-none">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("Taxbydefault")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={taxDataList}
                                          value={taxDataList.find(
                                            (item) =>
                                              item.value == customerData.tax_id,
                                          )}
                                          onChange={(selectedOption) => {
                                            setCustomerData({
                                              ...customerData,
                                              tax_id: selectedOption
                                                ? selectedOption.value
                                                : "",
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={"Select Tax By Default"}
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("PriceTablesByDefault")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={priceClassList}
                                          value={priceClassList.find(
                                            (item) =>
                                              item.value ==
                                              customerData.price_class_id,
                                          )}
                                          onChange={(selectedOption) => {
                                            setCustomerData({
                                              ...customerData,
                                              price_class_id: selectedOption
                                                ? selectedOption.value
                                                : "",
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={
                                            "Select Price Tables By Default"
                                          }
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("Maturity")}
                                    </Label>
                                    <span className="text-danger">*</span>

                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={maturityDatesList}
                                          value={maturityDatesList.find(
                                            (item) =>
                                              item.value ==
                                              customerData.maturity_date_id,
                                          )}
                                          onChange={(selectedOption) => {
                                            setCustomerData({
                                              ...customerData,
                                              maturity_date_id: selectedOption
                                                ? selectedOption.value
                                                : "",
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={"Select Maturity"}
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("payment_day")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <input
                                          className="form-control input-search"
                                          type="number"
                                          value={customerData.payment_day}
                                          onChange={(e) => {
                                            setCustomerData({
                                              ...customerData,
                                              payment_day: e.target.value,
                                            });
                                          }}
                                          name={`payment_day`}
                                          maxLength={50}
                                          placeholder="Payment day"
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("globalDiscount")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <input
                                          className="form-control input-search"
                                          type="number"
                                          value={
                                            customerData.global_discount_id
                                          }
                                          onChange={(e) => {
                                            setCustomerData({
                                              ...customerData,
                                              global_discount_id:
                                                e.target.value,
                                            });
                                          }}
                                          name={`global_discount_id`}
                                          maxLength={50}
                                          placeholder="Global Discount"
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4 d-none">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("CommercialDiscount")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <input
                                          className="form-control input-search"
                                          type="number"
                                          value={
                                            customerData.commercial_discount_id
                                          }
                                          onChange={(e) => {
                                            setCustomerData({
                                              ...customerData,
                                              commercial_discount_id:
                                                e.target.value,
                                            });
                                          }}
                                          name={`Commercial_discount_id`}
                                          maxLength={50}
                                          placeholder="Global Discount"
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("credit_limit")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <input
                                          className="form-control input-search"
                                          type="number"
                                          value={customerData.credit_limit}
                                          onChange={(e) => {
                                            setCustomerData({
                                              ...customerData,
                                              credit_limit: e.target.value,
                                            });
                                          }}
                                          name={`credit_limit`}
                                          maxLength={50}
                                          placeholder="Credit limit"
                                        />
                                        {errors.credit_limit && (
                                          <span className="input-error">
                                            {errors.credit_limit}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("paymentMethod")}
                                    </Label>
                                    <span className="text-danger">*</span>

                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={paymentMethodList}
                                          value={paymentMethodList.find(
                                            (item) =>
                                              item.value ==
                                              customerData.payment_method_id,
                                          )}
                                          onChange={(selectedOption) => {
                                            setCustomerData({
                                              ...customerData,
                                              payment_method_id: selectedOption
                                                ? selectedOption.value
                                                : "",
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={"Select Payment Method"}
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("deliveryMethod")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={deliveryMethodList}
                                          value={deliveryMethodList.find(
                                            (item) =>
                                              item.value ==
                                              customerData.delivery_method_id,
                                          )}
                                          onChange={(selectedOption) => {
                                            setCustomerData({
                                              ...customerData,
                                              delivery_method_id: selectedOption
                                                ? selectedOption.value
                                                : "",
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={"Select Payment Method"}
                                        />
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("salesmen")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <Select
                                          className="my-select-v"
                                          options={salesmenList}
                                          value={salesmenList.find(
                                            (item) =>
                                              item.value ===
                                              customerData.salesman_id,
                                          )}
                                          onChange={(selectedOption) => {
                                            setCustomerData({
                                              ...customerData,
                                              salesman_id: selectedOption
                                                ? selectedOption.value
                                                : "",
                                            });
                                          }}
                                          isSearchable={true}
                                          isClearable={true}
                                          placeholder={"Select Salesmen"}
                                        />
                                        {errors.salesman_id && (
                                          <span className="input-error">
                                            {errors.salesman_id}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4">
                                  <FormGroup>
                                    <Label className="col-form-label ml-2 Label-my">
                                      {t("notes")}
                                    </Label>
                                    <div className="col-xl-12">
                                      <div className="input-div">
                                        <input
                                          className="form-control input-search"
                                          type="text"
                                          value={customerData.notes}
                                          onChange={(e) => {
                                            setCustomerData({
                                              ...customerData,
                                              notes: e.target.value,
                                            });
                                          }}
                                          name={`notes`}
                                          maxLength={50}
                                          placeholder="notes"
                                        />
                                      </div>
                                      {errors.notes && (
                                        <span className="input-error">
                                          {errors.notes}
                                        </span>
                                      )}
                                    </div>
                                  </FormGroup>
                                </div>

                                <div className="col-md-4" />
                                <div className="col-md-4" />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col ms-2">
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => navigate("/customers")}
                          >
                            <i className="bi bi-arrow-left"> </i> {t("back")}
                          </button>
                        </div>
                        <div className="col">
                          <div className="d-flex justify-content-end nxt-btn">
                            {activeCustomerTab === "3" ? (
                              <button type="button" className="btn btn-primary">
                                {t("alternateAddress")}{" "}
                                <i className="bi bi-check2"></i>
                              </button>
                            ) : isModifyButtonLoad ? (
                              <button type="submit" className="btn btn-primary">
                                Loading...
                              </button>
                            ) : (
                              <button type="submit" className="btn btn-primary">
                                {t("submit")} <i className="bi bi-check2"></i>
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AddCustomerMoloni;
